import React, { useState } from 'react'

import CampaignMagnetScore from '../sandBoxDataTable/campaignMagnetScore'
import { Box, Grid, IconButton, Typography } from '@mui/material'

import { Close } from '@mui/icons-material'
import TextGrid from './textGrid'
import { VerbatimGrid, VerbatimImageVideoGrid, MuiIconButton } from '../../../../../components'
import { IconReportSearch, IconReportMore } from '../../../../../assets/images/icons'
import NanoDataGridV2 from '../../nanoDataGridV2'
import { getObjectAsArray } from '../../../../../util'
import AdaptiveGauge from '../guardChart'

import {
  CampaignGraphsRoot,
  CardHeading,
  HeadingRow,
  VerbatimWrap,
  PageBreakerForPPT,
  TableHeadingRow,
  CampaignMagnetScoreGraphWrapper,
  TriggerInnerWrapper
} from './style'

const CampaignGraphs = ({ section, row, title, isLast }) => {
  const [selectedRow, setSelectedRow] = useState('')
  const [nestedSelectedRow, setNestedSelectedRow] = useState()
  const [selectedRowType, setSelectedRowType] = useState('')

  const pre = (selectedItem, selectedSection) => {
    const items = getObjectAsArray(selectedItem.element.DriverAttributes.DriverAttributeElement)
    let max = 0
    for (let index = 0; index < items.length; index++) {
      const item = items[index]
      if (item.Percent > max) {
        max = item.Percent
      }
    }
    const graphsData = items.map((item) => {
      const barData = [
        {
          Positive: item.PositivePercent,
          Neutral: item.NeutralPercent,
          Mixed: item.MixedPercent,
          Negative: item.NegativePercent,
        },
      ]
      return {
        element: item,
        id: item.AttributeId,
        barData: barData,
        heading: item.AttributeName,
        maxWidth: '90%',
        maxPercentRatio: max,
        valueInPercent: true,
        verbatim: item?.Verbatim?.VerbatimElement || [],
      }
    })
    setSelectedRow({
      graphs: graphsData,
      heading: selectedItem.heading,
      rowId: selectedItem.id,
    })
  }

  return (
    <CampaignGraphsRoot className={`sectionWrap driverDeepdive ${section.type === 'Triggers' ? 'triggerOuterWrapper' : 'subTrigger'}`}>

      <Grid
        container
        wrap='nowrap'
        className={`sectionWrap  ${section.type === 'ImpactBrandPerception' ? '' : 'campaignTriggersRow'} rowId__${section.id}`}
      >
        <Grid style={{ overflow: 'hidden' }} item sm='12'>
          {section.heading && (
            <CardHeading
              className={`${section.type} graphHeadingWrapper ${section.type === 'ImpactBrandPerception' ? 'campaignTriggersRow ' + (section.graphs.length > 4 ? 'campaignTriggersRowNewSlidePPT' : '') : ''}`}
            >
              {section.heading}
            </CardHeading>
          )}
          <Box sx={{ display: nestedSelectedRow ? 'none' : 'block' }} className={`${section.type === 'Triggers' ? 'triggerInnerWrapper' : ''}`}>
            {section.type !== 'Triggers' && <TableHeadingRow className='tableHeadingRow' />}

            {section.graphs.map((graph) => {

              if(graph.id === 'CampaignMagnetScore') {
                return (
                  <CampaignMagnetScoreGraphWrapper>
                    <AdaptiveGauge size="large" value={graph.barData[0].Warning} />
                    <p>Campaign Magnet Score</p>
                  </CampaignMagnetScoreGraphWrapper>
                )
              }

              const isSelected = selectedRow.id === graph.id
              return (
                <>
                  <Box
                    className={`graphWrapper ${section.type === 'ImpactBrandPerception' ? 'campaignTriggersRow' : ''}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      paddingRight: '20px',
                    }}
                    key={graph.id}
                  >
                    <CampaignMagnetScore
                      heading={graph.heading}
                      barData={graph.barData}
                      showInside={true}
                      valueInPercent={graph.valueInPercent}
                      maxPercentRatio={graph.maxPercentRatio}
                      endIcon={graph.endIcon}
                      maxWidth={graph.maxWidth}
                      background={graph.background}
                      verbatim={graph.verbatim}
                    />
                    {!!graph?.verbatim && (
                      <>
                        <IconButton
                          onClick={() => {
                            pre(graph, section)
                            setSelectedRowType('bars')
                          }}
                          size='small'
                        >
                          <IconReportSearch /> aaaaa
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            setSelectedRow(graph)
                            setSelectedRowType('verbatim')
                          }}
                          size='small'
                        >
                          <IconReportMore /> bbbbb
                        </IconButton>
                      </>
                    )}
                  </Box>

                  <Box className={`NestedLevel2Wrap _${section.id} __${selectedRow.rowId}`}>
                    {selectedRow && selectedRowType === 'verbatim' && (
                      <VerbatimWrap>
                        <HeadingRow>
                          <Typography className='headingRowTitle aaaaaaaaaaaaa'>{selectedRow.heading} 2222222</Typography>
                          <IconButton onClick={() => setSelectedRow('')} size='small'>
                            <Close />
                          </IconButton>
                        </HeadingRow>
                        <VerbatimImageVideoGrid
                          data={selectedRow.verbatim}
                          insightsElementId={row.InsightsElementId}
                        />
                      </VerbatimWrap>
                    )}
                    {selectedRow && selectedRowType === 'bars' && (
                      <VerbatimWrap
                        sx={{
                          background: '#F6F6F5 !important',
                          paddingTop: '0 !important',
                          marginTop: '40px',
                        }}
                      >
                        <HeadingRow>
                          <Typography
                            sx={{
                              fontSize: '17px !important',
                              fontWeight: '400 !important',
                              minHeight: '28px',
                              height: '34px',
                              lineHeight: '34px',
                              marginBottom:' 8px',
                            }}
                            className='headingRowTitle bbbbbbbbbbb'
                          >
                            {selectedRow.heading} AAAAAAAAAAAA
                          </Typography>
                          <IconButton
                            onClick={() => {
                              setSelectedRow('')
                              setNestedSelectedRow('')
                            }}
                            size='small'
                          >
                            <Close />
                          </IconButton>
                        </HeadingRow>

                        {selectedRow?.graphs?.map((graph) => {
                          if (!Array.isArray(graph?.verbatim)) {
                            graph.verbatim = [graph?.verbatim]
                          }

                          return (
                            <Box
                              className='graphWrapper graph2'
                              sx={{
                                display: 'flex',
                                // background: isSelected ? '#F5F5F5' : 'transparent !important',
                                alignItems: 'center',
                                width: '100%',
                                paddingRight: '20px',
                                position: 'relative',
                              }}
                              key={graph.id}
                            >
                              <CampaignMagnetScore
                                heading={graph.heading}
                                barData={graph.barData}
                                showInside={true}
                                valueInPercent={graph.valueInPercent}
                                maxPercentRatio={graph.maxPercentRatio}
                                endIcon={graph.endIcon}
                                maxWidth={graph.maxWidth}
                                background={graph.background}
                                verbatim={graph.verbatim}
                              />
                              {!!graph?.verbatim && (
                                <IconButton onClick={() => setNestedSelectedRow(graph)} size='small'>
                                  <IconReportMore />
                                </IconButton>
                              )}
                            </Box>
                          )
                        })}
                      </VerbatimWrap>
                    )}
                  </Box>
                </>
              )
            })}
          </Box>

          {/* {nestedSelectedRow && (
            <VerbatimWrap>
              <HeadingRow>
                <Typography className='headingRowTitle'>{nestedSelectedRow.heading}</Typography>
                <IconButton onClick={() => setNestedSelectedRow('')} size='small'>
                  <Close />
                </IconButton>
              </HeadingRow>
              <VerbatimImageVideoGrid
                data={nestedSelectedRow.verbatim}
                insightsElementId={row.InsightsElementId}
              />
            </VerbatimWrap>
          )} */}
        </Grid>
      </Grid>

      {section.type === 'Triggers' && <TriggerInnerWrapper
        className={'sectionWrap triggerLastInnerWrapper'}
      >
          {!section.heading && <TextGrid row={row} />}
      </TriggerInnerWrapper>}


      {!isLast && section.type === 'ImpactBrandPerception' && (
        <PageBreakerForPPT container className='campaignTriggersRow pageBreakerForPPT'>
          <b>PageBreak</b>
        </PageBreakerForPPT>
      )}
    </CampaignGraphsRoot>
  )
}

export default CampaignGraphs
